/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Payin admin
 * Payin application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payinKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType, type BodyType } from '../../shared/api/kyMutator';
import {
    type AdminPayinTicketServiceCountTicketsParams,
    type AdminPayinTicketServiceListTicketsParams,
    type GoogleRpcStatus,
    type PayinAdminTicketV1CountTicketsResponse,
    type PayinAdminTicketV1ListTicketsResponse,
    type PayinAdminTicketV1ResolveTicketRequest,
    type PayinAdminTicketV1ResolveTicketResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };

    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') { continue; }

        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }

    return result;
};

export const getAdminPayinTicketServiceCountTicketsUrl = (params?: AdminPayinTicketServiceCountTicketsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['filter.statuses', 'filter.priorities'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/ticket/count?${stringifiedParams}` : '/v1/ticket/count';
};

export const adminPayinTicketServiceCountTickets = async (
    params?: AdminPayinTicketServiceCountTicketsParams,
    options?: RequestInit,
): Promise<PayinAdminTicketV1CountTicketsResponse> => {
    return payinKyMutator<PayinAdminTicketV1CountTicketsResponse>(getAdminPayinTicketServiceCountTicketsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinTicketServiceCountTicketsQueryKey = (params?: AdminPayinTicketServiceCountTicketsParams) => {
    return ['/v1/ticket/count', ...(params ? [params] : [])] as const;
};

export const getAdminPayinTicketServiceCountTicketsQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTicketServiceCountTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinTicketServiceCountTicketsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>> = ({ signal }) =>
        adminPayinTicketServiceCountTickets(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTicketServiceCountTicketsQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>
>;
export type AdminPayinTicketServiceCountTicketsQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTicketServiceCountTickets<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinTicketServiceCountTicketsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTicketServiceCountTickets<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTicketServiceCountTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTicketServiceCountTickets<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTicketServiceCountTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTicketServiceCountTickets<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTicketServiceCountTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceCountTickets>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTicketServiceCountTicketsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTicketServiceListTicketsUrl = (params?: AdminPayinTicketServiceListTicketsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['filter.statuses', 'filter.priorities'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/tickets?${stringifiedParams}` : '/v1/tickets';
};

export const adminPayinTicketServiceListTickets = async (
    params?: AdminPayinTicketServiceListTicketsParams,
    options?: RequestInit,
): Promise<PayinAdminTicketV1ListTicketsResponse> => {
    return payinKyMutator<PayinAdminTicketV1ListTicketsResponse>(getAdminPayinTicketServiceListTicketsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinTicketServiceListTicketsQueryKey = (params?: AdminPayinTicketServiceListTicketsParams) => {
    return ['/v1/tickets', ...(params ? [params] : [])] as const;
};

export const getAdminPayinTicketServiceListTicketsQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTicketServiceListTicketsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinTicketServiceListTicketsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>> = ({ signal }) =>
        adminPayinTicketServiceListTickets(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTicketServiceListTicketsQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>
>;
export type AdminPayinTicketServiceListTicketsQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTicketServiceListTickets<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinTicketServiceListTicketsParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTicketServiceListTickets<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTicketServiceListTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTicketServiceListTickets<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTicketServiceListTicketsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTicketServiceListTickets<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTicketServiceListTicketsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceListTickets>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTicketServiceListTicketsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTicketServiceResolveTicketUrl = () => {
    return '/v1/tickets/resolve';
};

export const adminPayinTicketServiceResolveTicket = async (
    payinAdminTicketV1ResolveTicketRequest: PayinAdminTicketV1ResolveTicketRequest,
    options?: RequestInit,
): Promise<PayinAdminTicketV1ResolveTicketResponse> => {
    return payinKyMutator<PayinAdminTicketV1ResolveTicketResponse>(getAdminPayinTicketServiceResolveTicketUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinAdminTicketV1ResolveTicketRequest),
    });
};

export const getAdminPayinTicketServiceResolveTicketQueryKey = (
    payinAdminTicketV1ResolveTicketRequest?: BodyType<PayinAdminTicketV1ResolveTicketRequest>,
) => {
    return ['POST', '/v1/tickets/resolve', payinAdminTicketV1ResolveTicketRequest] as const;
};

export const getAdminPayinTicketServiceResolveTicketQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTicketV1ResolveTicketRequest: BodyType<PayinAdminTicketV1ResolveTicketRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayinTicketServiceResolveTicketQueryKey(payinAdminTicketV1ResolveTicketRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>> = ({ signal }) =>
        adminPayinTicketServiceResolveTicket(payinAdminTicketV1ResolveTicketRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTicketServiceResolveTicketQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>
>;
export type AdminPayinTicketServiceResolveTicketQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTicketServiceResolveTicket<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTicketV1ResolveTicketRequest: BodyType<PayinAdminTicketV1ResolveTicketRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTicketServiceResolveTicket<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTicketV1ResolveTicketRequest: BodyType<PayinAdminTicketV1ResolveTicketRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTicketServiceResolveTicket<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTicketV1ResolveTicketRequest: BodyType<PayinAdminTicketV1ResolveTicketRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTicketServiceResolveTicket<
    TData = Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTicketV1ResolveTicketRequest: BodyType<PayinAdminTicketV1ResolveTicketRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTicketServiceResolveTicket>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTicketServiceResolveTicketQueryOptions(
        payinAdminTicketV1ResolveTicketRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
